import axios from "axios";
import { BOOK_PUBLISHERS } from "../../types/BookPublisherType";

const getAllBookPublisher = (data) => {
	return {
		type: BOOK_PUBLISHERS,
		payload: data,
	};
};

export const loadAllBookPublisher = ({ page, limit, name, address, phone, email }) => {
	return async (dispatch) => {
		try {
			const params = new URLSearchParams();
			params.set("page", String(page));
			params.set("count", String(limit));
			if (name) params.set("name", name);
			if (address) params.set("address", address);
			if (phone) params.set("phone", phone);
			if (email) params.set("email", email);
			const { data } = await axios.get(`book-publisher?${params.toString()}`);
			dispatch(getAllBookPublisher(data));
		} catch (error) {
			console.log(error.message);
		}
	};
};